import { CommentReportState, CommentReportActionTypes, READ_COMMENT_REPORT_DATA_REQUEST, READ_COMMENT_REPORT_DATA_SUCCESS, READ_COMMENT_REPORT_DATA_FAILURE } from "store/reducers/types/commentReport/commentReport";

const defaultState: CommentReportState = {
  isLoading: false,
  errorMessage: ""
};

export default function commentReport(state = defaultState, action: CommentReportActionTypes): CommentReportState {
  switch (action.type) {
    case READ_COMMENT_REPORT_DATA_REQUEST:
      return {
        ...state,
        isLoading: true
      };
    case READ_COMMENT_REPORT_DATA_SUCCESS:
      return {
        ...state,
        contents: action.contents,
        isLoading: false,
        errorMessage: ""
      };
    case READ_COMMENT_REPORT_DATA_FAILURE:
      return {
        ...state,
        isLoading: false,
        errorMessage: ""
      };
    default:
      return state;
  }
};